import { render, staticRenderFns } from "./RiskNodeAppender.vue?vue&type=template&id=038d543f&scoped=true&"
import script from "./RiskNodeAppender.vue?vue&type=script&lang=js&"
export * from "./RiskNodeAppender.vue?vue&type=script&lang=js&"
import style0 from "./RiskNodeAppender.vue?vue&type=style&index=0&id=038d543f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d543f",
  null
  
)

export default component.exports